
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaitokonkandarshancabbooking() {



    const cardData =
    {
        keyword: 'Mumbai to Konkan Darshan Cab Booking',
        heading: 'Vedant Travels: Mumbai to Konkan Darshan Cab Booking',
        headingDescription: 'Explore the beauty of Konkan with Vedant Travels Mumbai to Konkan Darshan Cab Service. Whether you are looking for pristine beaches, ancient temples, or lush green landscapes, our comfortable and reliable cabs ensure a hassle-free journey. Choose from our well-maintained sedans, SUVs, and luxury cars for a smooth and safe ride. With 24/7 availability, competitive pricing, and flexible pickup & drop-off options, Vedant Travels makes your Mumbai to Konkan trip convenient and enjoyable.',

        top: 'Top Places to Visit in Mahabaleshwar with Vedant Travels',

"topPlaces": [
    {
        "title": "Ganpatipule Beach & Temple",
        "description": "Located in Ratnagiri district, Ganpatipule Beach is famous for its pristine coastline and the revered Ganpatipule Temple dedicated to Lord Ganesha. The beach offers scenic views, water sports, and a peaceful atmosphere for spiritual seekers and nature lovers."
    },
    {
        "title": "Tarkarli Beach & Sindhudurg Fort",
        "description": "Tarkarli Beach, known for its crystal-clear waters and white sand, is a perfect destination for water sports lovers. Scuba diving, snorkeling, and dolphin watching are popular activities here. Nearby, Sindhudurg Fort, built by Chhatrapati Shivaji Maharaj, is a must-visit for history buffs."
    },
    {
        "title": "Alibaug – Coastal Paradise",
        "description": "A perfect weekend getaway, Alibaug offers clean beaches, historic forts, and delicious seafood. Top attractions include Alibaug Beach, Kolaba Fort, Nagaon Beach, and Kashid Beach."
    },
    {
        "title": "Harihareshwar & Diveagar Beach",
        "description": "Harihareshwar Beach, often called the Dakshin Kashi, is home to the famous Harihareshwar Temple dedicated to Lord Shiva. Nearby, Diveagar Beach is known for its peaceful vibes, white sand, and breathtaking sunset views."
    },
    {
        "title": "Murud-Janjira Fort",
        "description": "This unconquered sea fort, located on an island, is a marvel of ancient architecture. It offers spectacular views of the Arabian Sea and holds a rich history of the Siddis who ruled it."
    },
    {
        "title": "Dapoli – Mini Mahabaleshwar",
        "description": "Dapoli, a hill station in Konkan, is famous for its cool climate, lush greenery, and scenic beaches. Visit Karde Beach, Murud Beach, and Panhalekaji Caves for a mix of nature and history."
    },
    {
        "title": "Guhagar – Unexplored Konkan Beauty",
        "description": "Guhagar Beach is known for its clean, unspoiled beauty. Nearby, you can visit the Velneshwar Temple, Hedvi Ganesh Temple, and Dabhol Port."
    },
    {
        "title": "Ratnagiri – Land of Alphonso Mangoes",
        "description": "Famous for Alphonso mangoes, Ratnagiri also boasts stunning beaches like Bhatye Beach, Mandvi Beach, and Aare Ware Beach. Don’t miss Thibaw Palace and Ratnadurg Fort."
    },
    {
        "title": "Malvan – Seafood & Scuba Diving Hub",
        "description": "Home to the famous Sindhudurg Fort, Malvan is a paradise for seafood lovers and adventure seekers. Enjoy scuba diving, snorkeling, and authentic Malvani cuisine."
    },
    {
        "title": "Vengurla – Hidden Gem of Konkan",
        "description": "Less crowded than other Konkan destinations, Vengurla offers serene beaches, coconut groves, and temples like Sargeshwar Temple. Shiroda Beach and Sagareshwar Beach are must-visit spots here."
    }
],

"services": [
    {
        "name": "Mumbai to Konkan Darshan Cab by Vedant Travels",
        "description": "Embark on a spiritual and scenic journey from Mumbai to Konkan with Vedant Travels. Our well-maintained cabs and experienced drivers ensure a smooth and comfortable ride to explore the beautiful Konkan region, known for its serene beaches and temples."
    },
    {
        "name": "Mumbai to Konkan Tour Taxi",
        "description": "Looking for a reliable taxi for your Konkan tour from Mumbai? Vedant Travels offers a variety of vehicle options for a comfortable and stress-free ride. Our professional drivers will take you to all the must-visit spots in Konkan, making your trip memorable and enjoyable."
    },
    {
        "name": "Konkan Darshan Taxi Booking",
        "description": "Booking a taxi for your Konkan Darshan trip from Mumbai is easy with Vedant Travels. Whether you’re planning to visit temples or explore the scenic beauty of Konkan, our taxi booking service ensures a convenient and hassle-free experience."
    },
    {
        "name": "Mumbai to Konkan Darshan Trip",
        "description": "Plan your Konkan Darshan trip with Vedant Travels for a peaceful and pleasant journey. We offer flexible and comfortable travel options, allowing you to enjoy the beauty and spirituality of the Konkan region, all while traveling in comfort."
    },
    {
        "name": "Konkan Cab Hire from Mumbai",
        "description": "Rent a cab for your Konkan trip with Vedant Travels. Our cab hire services provide flexibility and convenience, allowing you to explore the Konkan region at your own pace. Choose from a wide range of vehicles to suit your group size and travel preferences."
    },
    {
        "name": "Mumbai to Konkan Taxi Service",
        "description": "For a reliable and comfortable taxi service from Mumbai to Konkan, Vedant Travels is your trusted choice. We offer affordable rates, experienced drivers, and well-maintained vehicles to ensure a smooth and safe journey to the Konkan region."
    },
    {
        "name": "Mumbai to Konkan One Way Cab",
        "description": "If you're looking for a one-way taxi from Mumbai to Konkan, Vedant Travels offers convenient one-way cab services. Book your ride with us for a stress-free journey, whether you're visiting for a pilgrimage, sightseeing, or a weekend getaway."
    },
    {
        "name": "Mumbai to Konkan Taxi Fare",
        "description": "At Vedant Travels, we provide competitive and transparent pricing for your Mumbai to Konkan journey. We aim to offer affordable taxi fares with no hidden costs, ensuring that you get the best value for your trip. Contact us for an accurate fare quote."
    },
    {
        "name": "Konkan Darshan Car Hire",
        "description": "Rent a car for your Konkan Darshan trip with Vedant Travels. We offer a variety of vehicles to ensure your journey is as comfortable and convenient as possible. With professional drivers and reliable vehicles, your trip to Konkan will be a memorable one."
    },
    {
        "name": "Mumbai to Konkan Darshan Innova",
        "description": "For a premium travel experience, book an Innova for your Mumbai to Konkan Darshan trip. The Innova offers ample space, luxury, and comfort, making it perfect for families or groups. Enjoy a smooth and enjoyable ride while exploring the spiritual beauty of Konkan."
    }
],



"tableData": [
    ["Mumbai to Konkan Darshan Cab", "Mumbai to Konkan Tour Taxi"],
    ["Konkan Darshan Taxi Booking", "Mumbai to Konkan Darshan Trip"],
    ["Konkan Cab Hire from Mumbai", "Mumbai to Konkan Taxi Service"],
    ["Mumbai to Konkan One Way Cab", "Mumbai to Konkan Taxi Fare"],
    ["Konkan Darshan Car Hire", "Mumbai to Konkan Darshan Innova"]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we prioritize punctuality. Whether you're planning a religious, leisure, or cultural trip, our drivers ensure timely pickups and drop-offs, making your Mumbai to Konkan Darshan trip seamless and stress-free."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "Our fleet includes spacious and well-maintained vehicles that are perfect for long-distance travel. Equipped with air conditioning, comfortable seating, and ample legroom, our vehicles ensure a pleasant and relaxing journey along the Konkan coast."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are experienced professionals, familiar with the Konkan route and its scenic beauty. They ensure that your journey is not only safe but also comfortable, and they know the best routes to make the most of your trip."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers competitive pricing for your Konkan Darshan trip. We have a transparent pricing model, ensuring you know exactly what you’re paying for, with no hidden charges or surprises."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Your safety is our priority. Our vehicles are regularly serviced and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers adhere to strict safety standards to ensure your journey is worry-free."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you want to start your Konkan Darshan early in the morning or plan a late-night return, Vedant Travels is available around the clock. Our customer support team is ready to assist with your booking and itinerary at any time."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Konkan Darshan cab is easy and hassle-free. You can book online via our website or mobile app, or contact our customer service team for assistance with your reservation."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "We offer customized travel packages for your Konkan Darshan trip. Whether you wish to visit famous beaches, temples, forts, or explore the coastal towns, we can create a personalized itinerary that suits your schedule and preferences."
    }
  ]


    }
    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Konkan Darshan cab with Vedant Travels?',
            answer: 'You can easily book your cab online via our website or mobile app. Alternatively, you can call our customer service team for assistance in booking your cab.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and are well-versed with the best routes to Konkan. They ensure a safe and smooth journey throughout your trip.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Mumbai to Konkan Darshan travel?',
            answer: 'We offer a variety of well-maintained vehicles, including sedans, SUVs, and luxury cars. All our vehicles are comfortable for long journeys, ensuring a smooth ride along the scenic Konkan coast.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai to Konkan Darshan cab rental?',
            answer: 'We accept multiple payment methods, including cash, credit/debit cards, and online payment via our app for your convenience.',
        },
        {
            id: 5,
            question: 'Can I book a round trip for Konkan Darshan?',
            answer: 'Yes, you can book a round-trip cab for your Konkan Darshan journey. Simply provide your return details when booking, and we will ensure a smooth trip back to Mumbai.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting or detours will be clearly communicated to you upfront. We prioritize transparency and ensure you’re aware of all costs before your trip.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Konkan?',
            answer: 'Yes, we offer sightseeing services as part of your Mumbai to Konkan Darshan tour. Visit attractions like Alibaug, Ganpatipule, Dapoli, and other scenic beaches and temples along the Konkan coast with a trusted driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Mumbai to Konkan Darshan cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional or specialized luggage, please let us know during booking, and we will make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel to Konkan?',
            answer: 'Yes, we provide corporate travel services for business trips or group outings to Konkan. We offer a professional and comfortable travel experience for corporate teams.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Mumbai to Konkan Darshan?',
            answer: 'Vedant Travels offers a reliable, affordable, and comfortable service for your Konkan Darshan journey. With experienced drivers, well-maintained vehicles, and transparent pricing, we ensure that your trip is safe, smooth, and memorable.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Vikram Joshi",
            title: "Traveler",
            quote: "I traveled from Mumbai to Konkan with Vedant Travels, and it was a wonderful experience. The car was very comfortable, the driver was knowledgeable about the routes, and we had an enjoyable trip exploring Konkan. Highly recommend their service!",
            rating: 5,
        },
        {
            name: "Mrs. Neha Reddy",
            title: "Family Traveler",
            quote: "Our family booked a cab with Vedant Travels for a Konkan Darshan trip. The driver was very friendly and professional, and the vehicle was spacious and clean. We had an amazing time exploring the beautiful Konkan coast!",
            rating: 5,
        },
    ];
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
      
   


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Konkan Darshan Cab Booking",
  "image": "https://vedanttravels.in/assets/images/mumbai-to-konkan-darshan-cab-booking.jpg",
  "description": "Book Mumbai to Konkan Darshan cab with Vedant Travels for an enjoyable and scenic coastal journey. Choose from AC sedans, SUVs, and tempo travellers for one-way and round trips covering popular Konkan destinations.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4599",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/mumbai-to-konkan-darshan-cab-booking"
  }
};





    return (
        <div>
           
                 
<Helmet>
  <title>Mumbai to Konkan Darshan Cab Booking | Scenic Coastal Ride | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book Mumbai to Konkan Darshan cab with Vedant Travels for an enjoyable and scenic coastal journey. Choose from AC sedans, SUVs, and tempo travellers for one-way and round trips covering popular Konkan destinations." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Konkan Darshan Cab Booking, Konkan Darshan Taxi Mumbai, Mumbai to Konkan Coastal Cab, Vedant Travels Mumbai Konkan, Scenic Cab Mumbai to Konkan, AC Cab Mumbai Konkan Darshan, SUV Cab Mumbai Konkan, Outstation Cab Mumbai to Konkan" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/83.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitokonkandarshancabbooking;